import { render, staticRenderFns } from "./FiltertronTray.vue?vue&type=template&id=8456051e&"
import script from "./FiltertronTray.vue?vue&type=script&lang=js&"
export * from "./FiltertronTray.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports